import { useEffect, useState } from 'react';

const TIMEOUT = 500;

export const useDebounce = <T>(value: T, delay = TIMEOUT) => {
  const [debouncesValue, setDebouncesValue] = useState<T>(value);

  useEffect(() => {
    const timerId = setTimeout(() => setDebouncesValue(value), delay);

    return () => {
      clearTimeout(timerId);
    };
  }, [value, delay]);

  return debouncesValue;
};
